const NAME_MAX_LENGTH = 30

export const AUTHENTICATION_WIZARD_TEXT = {
  'auth_wizard.welcome_title': {
    'en-GB': 'Sign In or Create an Account',
    'nl-NL': 'Inloggen of aanmelden',
  },
  'auth_wizard.welcome_subtitle': {
    'en-GB': 'Never miss a special occasion again!',
    'nl-NL': 'Mis nooit meer een speciaal moment!',
  },
  'auth_wizard.sign_in_title': {
    'en-GB': 'Sign In',
    'nl-NL': 'Inloggen',
  },
  'auth_wizard.register_title': {
    'en-GB': 'Create an Account',
    'nl-NL': 'Aanmelden',
  },
  'auth_wizard.account_linking_title': {
    'en-GB': 'Linking Your Account',
    'nl-NL': 'Koppel je account',
  },
  'auth_wizard.account_linking.description': {
    'en-GB': (provider: string) =>
      `To link your ${provider} account with Moonpig you need to enter your Moonpig password.`,
    'nl-NL': /* istanbul ignore next */ (provider: string) =>
      `Vul het wachtwoord in van je Greetz-account om je ${provider}-account te koppelen met Greetz.`,
  },
  'auth_wizard.account_linking.description_oidc': {
    'en-GB': (provider: string) =>
      `Please continue with ${provider} to link it with your social account.`,
    'nl-NL': /* istanbul ignore next */ (provider: string) =>
      `Ga verder met ${provider} om je Greetz account te koppelen aan je social media account.`,
  },
  'auth_wizard.welcome.error': {
    'en-GB': 'Failed to lookup account',
    'nl-NL': 'Account kon niet worden gevonden ',
  },
  'auth_wizard.welcome.error.account_disabled': {
    'en-GB': 'Your account is blocked. Please contact support for help.',
    'nl-NL':
      'Je account is geblokkeerd. Neem contact op met onze klantenservice en we helpen je verder.',
  },
  'auth_wizard.benefits.reminders_title': {
    'en-GB': 'Handy Reminders',
    'nl-NL': 'Handige Greetz-kalender',
  },
  'auth_wizard.benefits.reminders_content': {
    'en-GB': 'Never forget a special occasion again.',
    'nl-NL': 'Vergeet nooit meer een speciale gelegenheid.',
  },
  'auth_wizard.benefits.tracking_title': {
    'en-GB': 'Order Tracking',
    'nl-NL': 'Bestelling volgen',
  },
  'auth_wizard.benefits.tracking_content': {
    'en-GB': 'See when that surprise will be delivered.',
    'nl-NL': 'Check wanneer die ene verrassing wordt bezorgd.',
  },
  'auth_wizard.benefits.convenient_title': {
    'en-GB': 'Save Time & Money',
    'nl-NL': 'Bespaar tijd en geld',
  },
  'auth_wizard.benefits.convenient_content': {
    'en-GB': 'We curate the best gifts and discounts for your occasion.',
    'nl-NL': 'We vinden de beste cadeaus en korting voor jouw gelegenheid.',
  },
  'auth_wizard.continue': {
    'en-GB': 'Continue',
    'nl-NL': 'Doorgaan',
  },
  'auth_wizard.sign_in.title': {
    'en-GB': (storeName?: string) =>
      `Sign In or Create an Account | Moonpig${
        storeName ? /* istanbul ignore next */ ` ${storeName}` : ''
      }`,
    'nl-NL': /* istanbul ignore next */ (storeName?: string) =>
      `Log in of maak een account aan | Greetz${
        storeName ? ` ${storeName}` : ''
      }`,
  },
  'auth_wizard.sign_in.callback.title': {
    'en-GB': 'Returning you back to Moonpig...',
    'nl-NL': 'Je wordt teruggeleid naar Greetz...',
  },
  'auth_wizard.sign_in': {
    'en-GB': 'Sign In',
    'nl-NL': 'Inloggen',
  },
  'auth_wizard.benefits_title': {
    'en-GB': 'Moonpig Is Better Signed In!',
    'nl-NL': 'Ingelogd is Greetz beter!',
  },
  'auth_wizard.sign_in.error': {
    'en-GB': 'Sign in failed',
    'nl-NL': 'Aanmelden niet gelukt',
  },
  'auth_wizard.register': {
    'en-GB': 'Create Account',
    'nl-NL': 'Maak een account aan',
  },
  'auth_wizard.register.error': {
    'en-GB': 'Failed to create account',
    'nl-NL': 'Account aanmaken mislukt',
  },
  'auth_wizard.email_label': {
    'en-GB': 'Email',
    'nl-NL': 'E-mailadres',
  },
  'auth_wizard.email_error': {
    'en-GB': 'Please enter an email',
    'nl-NL': 'Voer een e-mailadres in',
  },
  'auth_wizard.password_error': {
    'en-GB': 'Sorry, that password does not meet the criteria shown below',
    'nl-NL':
      'Voer een wachtwoord in van minstens 8 tekens lang, waaronder minstens één hoofdletter, één kleine letter en één cijfer',
  },
  'auth_wizard.password_required_error': {
    'en-GB': 'Email and password required',
    'nl-NL': 'E-mail en wachtwoord verplicht',
  },
  'auth_wizard.terms_not_accepted': {
    'en-GB': 'Please accept the terms and conditions',
    'nl-NL': 'Accepteer de algemene voorwaarden',
  },
  'auth_wizard.password_label': {
    'en-GB': 'Password',
    'nl-NL': 'Wachtwoord',
  },
  'auth_wizard.register.firstName_label': {
    'en-GB': 'First Name',
    'nl-NL': 'Voornaam',
  },
  'auth_wizard.register.firstName_error': {
    'en-GB': 'Please enter your first name',
    'nl-NL': 'Voer een voornaam in',
  },
  'auth_wizard.register.lastName_label': {
    'en-GB': 'Last Name',
    'nl-NL': 'Achternaam',
  },
  'auth_wizard.register.lastName_error': {
    'en-GB': 'Please enter your last name',
    'nl-NL': 'Voer een achternaam in',
  },
  'auth_wizard.register.benefit_title': {
    'en-GB': 'Get more with a Moonpig account',
    'nl-NL': 'Meer gemak en voordeel met een Greetz-account',
  },
  'auth_wizard.register.benefit_save_addresses': {
    'en-GB': 'Save addresses',
    'nl-NL': 'Bewaar adressen',
  },
  'auth_wizard.register.benefit_order_history': {
    'en-GB': 'Order history',
    'nl-NL': 'Bestelgeschiedenis',
  },
  'auth_wizard.register.benefit_reminders': {
    'en-GB': 'Reminders',
    'nl-NL': 'Herinneringen',
  },
  'auth_wizard.register.benefit_more': {
    'en-GB': 'and more...',
    'nl-NL': 'en meer...',
  },
  'auth_wizard.register.info_create_password_heading': {
    'en-GB': 'Create Account',
    'nl-NL': 'Wachtwoord aanmaken',
  },
  'auth_wizard.register.info_create_password_message': {
    'en-GB':
      'We don’t recognise this email. Enter your details below to create an account',
    'nl-NL':
      'We herkennen dit e-mailadres niet. Vul hieronder je gegevens in om een account aan te maken.',
  },
  'auth_wizard.forgotten_message': {
    'en-GB': 'Reset your password to continue by clicking',
    'nl-NL': 'Om je wachtwoord opnieuw in te stellen en verder te gaan, klik',
  },
  'auth_wizard.forgotten_message_here': {
    'en-GB': 'here',
    'nl-NL': 'hier',
  },
  'auth_wizard.forgot_password': {
    'en-GB': 'Forgot Password?',
    'nl-NL': 'Wachtwoord vergeten?',
  },
  'auth_wizard.forgot_password_heading': {
    'en-GB': 'Reset Password?',
    'nl-NL': 'Wachtwoord opnieuw instellen?',
  },
  'auth_wizard.forgot_password_message': {
    'en-GB':
      "We'll send you an email with instructions on how to create a new password.",
    'nl-NL':
      'We sturen je een e-mail met instructies voor het aanmaken van een nieuw wachtwoord.',
  },
  'auth_wizard.forgot_password_send_email': {
    'en-GB': 'Reset Password',
    'nl-NL': 'Wachtwoord opnieuw instellen',
  },
  'auth_wizard.forgot_password_sent_heading': {
    'en-GB': 'Email Sent',
    'nl-NL': 'E-mail verzonden',
  },
  'auth_wizard.forgot_password_sent_message': {
    'en-GB':
      'Instructions on how to create a new password have been sent to you.',
    'nl-NL':
      'We hebben je een e-mail gestuurd met instructies voor het aanmaken van een nieuw wachtwoord.',
  },
  'auth_wizard.forgot_password_sent_ok': {
    'en-GB': 'Close',
    'nl-NL': 'Sluiten',
  },
  'auth_wizard.generic_error': {
    'en-GB': 'Oops, something went wrong…please try again.',
    'nl-NL': 'Oeps, er ging iets mis... probeer het opnieuw.',
  },
  'auth_wizard.back': {
    'en-GB': 'Go back',
    'nl-NL': 'Ga terug',
  },
  'auth_wizard.alternative_authentication_options_divider_text': {
    'en-GB': 'or continue with',
    'nl-NL': 'of ga verder met',
  },
  'auth_wizard.express_login': {
    'en-GB': 'Express Login',
    'nl-NL': 'Express login',
  },
  'auth_wizard.alternative_authentication_options_modal_thanks': {
    'en-GB': 'Thanks for your interest!',
    'nl-NL': 'Bedankt voor je belangstelling!',
  },
  'auth_wizard.alternative_authentication_options_not_ready': {
    'en-GB':
      'We’re working hard on this feature and it’s not ready yet. Please continue with your email.',
    'nl-NL':
      'We zijn druk bezig met deze functie, maar het is nog niet klaar. Ga verder met je e-mail.',
  },
  'auth_wizard.alternative_authentication_options_login_okay': {
    'en-GB': 'Okay',
    'nl-NL': 'Oké',
  },
  'auth_wizard.password_rule_length': {
    'en-GB': 'At least 8 characters',
    'nl-NL': 'Minimaal 8 tekens',
  },
  'auth_wizard.password_rule_number': {
    'en-GB': 'A number',
    'nl-NL': 'Een cijfer',
  },
  'auth_wizard.password_rule_uppercase': {
    'en-GB': 'An uppercase letter',
    'nl-NL': 'Een hoofdletter',
  },
  'auth_wizard.password_rule_lowercase': {
    'en-GB': 'A lowercase letter',
    'nl-NL': 'Een Kleine letter',
  },
  'auth_wizard.validate_email_header': {
    'en-GB': 'Everything look right?',
    'nl-NL': 'Ziet alles er goed uit?',
  },
  'auth_wizard.validate_email_message': {
    'en-GB':
      'We are unable to reach that mailbox. Please double-check your email.',
    'nl-NL':
      'We konden dit e-mailadres niet bereiken. Check even je e-mailadres.',
  },
  'auth_wizard.validate_email_change_email': {
    'en-GB': 'Change email',
    'nl-NL': 'Wijzig e-mailadres',
  },
  'auth_wizard.validate_email_continue': {
    'en-GB': 'Continue with this email',
    'nl-NL': 'Doorgaan met dit e-mailadres',
  },
  'auth_wizard.sign_in.cookies_alert': {
    'en-GB': 'Oops! You need to have cookies enabled to use this feature',
    'nl-NL':
      'Oeps! Je moet cookies toestaan om deze functie te kunnen gebruiken',
  },
  'auth_wizard.firstName_length_error': {
    'en-GB': `Please enter a first name with less than ${NAME_MAX_LENGTH} characters.`,
    'nl-NL': `Voer een voornaam in van minder dan ${NAME_MAX_LENGTH} tekens.`,
  },
  'auth_wizard.lastName_length_error': {
    'en-GB': `Please enter a last name with less than ${NAME_MAX_LENGTH} characters.`,
    'nl-NL': `Voer een achternaam in van minder dan ${NAME_MAX_LENGTH} tekens.`,
  },
  'auth_wizard.social_login.button': {
    'en-GB': 'Continue with ',
    'nl-NL': 'Doorgaan met ',
  },
  'auth_wizard.social_login.or': {
    'en-GB': 'or',
    'nl-NL': 'of',
  },
  'auth_wizard.link_account': {
    'en-GB': 'Link Account',
    'nl-NL': 'Koppel account',
  },
  'auth_wizard.sociallogin_unavailable_title': {
    'en-GB': 'Social Login Unavailable',
    'nl-NL': 'Social media zijn niet beschikbaar',
  },
  'auth_wizard.sociallogin_error.title': {
    'en-GB': 'Sorry! Something Went Wrong',
    'nl-NL': 'Sorry. Er ging iets mis',
  },
  'auth_wizard.sociallogin_error.body': {
    'en-GB': 'Please refresh the page or go back to login.',
    'nl-NL': 'Laad the pagina opnieuw of ga terug naar inloggen.',
  },
  'auth_wizard.sociallogin_unavailable_message': {
    'en-GB':
      'Sorry! We couldn’t find any social providers at the moment. Please proceed to Account Recovery to continue.',
    'nl-NL':
      'We konden geen social-mediaplatforms vinden. Klik op ‘Account herstellen’ om verder te gaan. ',
  },
  'auth_wizard.account_recovery': {
    'en-GB': 'Account Recovery',
    'nl-NL': 'Herstel je account',
  },
  'auth_wizard.sociallogin_description_with_providers': {
    'en-GB':
      'This address is linked to an existing account. Click below to sign in.',
    'nl-NL':
      'Dit adres is gekoppeld aan een bestaand account. Klik hieronder om in te loggen.',
  },
  'auth_wizard.sociallogin_description_with_no_social_login': {
    'en-GB':
      'The address is linked to an existing account. Please proceed to Account Recovery to continue.',
    'nl-NL':
      'Dit adres is gekoppeld aan een bestaand account. Ga verder naar herstel je account om door te gaan.',
  },
  'auth_wizard.account_linking.loading_text': {
    'en-GB': (providerName: string) => `Logging you in with ${providerName}`,
    'nl-NL': /* istanbul ignore next */ (providerName: string) =>
      `Aan het inloggen met ${providerName}`,
  },
  'auth_wizard.common.loading': {
    'en-GB': 'Loading...',
    'nl-NL': 'Aan het laden...',
  },
  'auth_wizard.private_email_modal.heading': {
    'en-GB': "Using 'hide my email' will create a new account",
    'nl-NL':
      "Gebruiken van 'verberg mijn e-mail' zal een nieuw account aanmaken",
  },
  'auth_wizard.private_email_modal.content': {
    'en-GB':
      "If you are already a Moonpig customer, your existing address book, reminders, order history, and Moonpig Plus subscription won't be transferred.",
    'nl-NL':
      'Als je al een Greetz-klant bent, worden je kalender, adresboek, en bestelgeschiedenis niet overgezet',
  },
  'auth_wizard.private_email_modal.button': {
    'en-GB': 'Got it',
    'nl-NL': 'Oké, verder',
  },
  'auth_wizard.private_email_modal.alt': {
    'en-GB': 'Apple hide my email',
    'nl-NL': 'Apple verberg mijn e-mail',
  },
  'auth_wizard.sign_in_with_code_form.title': {
    'en-GB': 'Enter the code we sent you',
    'nl-NL': 'Inloggen of aanmelden',
  },
  'auth_wizard.set_password.title': {
    'en-GB': 'Reset your password',
    'nl-NL': 'Wachtwoord opnieuw instellen',
  },
  'auth_wizard.sign_in_with_code_form.description': {
    'en-GB': 'The 6-digit code has been sent to',
    'nl-NL': 'De 6-cijferige code is verzonden naar',
  },
}
